module.exports = __webpack_public_path__ + "img/background-8.8543c9b7.jpg";